import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, UsersIcon, CalendarIcon, TrendingUpIcon, FileTextIcon, ChevronRightIcon } from 'lucide-react';
import { Company } from '../types/company';
import { CompanyLogo } from './CompanyLogo';
type CompanyCardProps = {
  company: Company;
  index: number;
  onClick: () => void;
};
export function CompanyCard({
  company,
  index,
  onClick
}: CompanyCardProps) {
  return <motion.button initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: index * 0.03
  }} onClick={onClick} className="w-full text-left bg-slate-800/30 hover:bg-slate-800/50 border border-slate-700/50 hover:border-slate-600 rounded-xl p-5 backdrop-blur-sm transition-all group" data-id="element-13">
      <div className="flex items-start gap-4" data-id="element-14">
        <CompanyLogo website={company.website} name={company.name} size="md" data-id="element-15" />

        <div className="flex-1 min-w-0" data-id="element-16">
          <div className="flex items-start justify-between gap-4" data-id="element-17">
            <div data-id="element-18">
              <h3 className="text-lg font-semibold text-white group-hover:text-amber-400 transition-colors" data-id="element-19">
                {company.name}
              </h3>
              <p className="text-sm text-slate-500" data-id="element-20">{company.nameChinese}</p>
            </div>

            <div className="flex items-center gap-2 shrink-0" data-id="element-21">
              <div className="px-2.5 py-1 bg-amber-500/10 border border-amber-500/20 rounded-full" data-id="element-22">
                <span className="text-xs font-semibold text-amber-400" data-id="element-23">
                  Score: {company.innovationScore}
                </span>
              </div>
              <ChevronRightIcon className="w-5 h-5 text-slate-600 group-hover:text-amber-500 transition-colors" data-id="element-24" />
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2 text-sm text-slate-400" data-id="element-25">
            <span className="flex items-center gap-1" data-id="element-26">
              <MapPinIcon className="w-3.5 h-3.5" data-id="element-27" />
              {company.city}
            </span>
            <span className="flex items-center gap-1" data-id="element-28">
              <UsersIcon className="w-3.5 h-3.5" data-id="element-29" />
              {company.employees.toLocaleString()}
            </span>
            <span className="flex items-center gap-1" data-id="element-30">
              <CalendarIcon className="w-3.5 h-3.5" data-id="element-31" />
              {company.founded}
            </span>
            <span className="flex items-center gap-1" data-id="element-32">
              <TrendingUpIcon className="w-3.5 h-3.5" data-id="element-33" />
              {company.revenue}
            </span>
            <span className="flex items-center gap-1" data-id="element-34">
              <FileTextIcon className="w-3.5 h-3.5" data-id="element-35" />
              {company.patents.toLocaleString()} patents
            </span>
          </div>

          <div className="flex flex-wrap gap-1.5 mt-3" data-id="element-36">
            <span className="px-2 py-0.5 bg-amber-500/10 text-amber-400/80 rounded text-xs font-mono" data-id="element-37">
              {company.industryCode}
            </span>
            <span className="px-2 py-0.5 bg-slate-700/50 text-slate-300 rounded text-xs" data-id="element-38">
              {company.industry}
            </span>
            <span className="px-2 py-0.5 bg-slate-700/50 text-slate-300 rounded text-xs" data-id="element-39">
              {company.fundingRound}
            </span>
            {company.tags.slice(0, 2).map(tag => <span key={tag} className="px-2 py-0.5 bg-slate-700/30 text-slate-400 rounded text-xs" data-id="element-40">
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </motion.button>;
}